// src/components/categories/FiltersBar.jsx
import React from "react";

const FiltersBar = ({
  season, setSeason, seasonOptions,
  selectedGenre, setSelectedGenre,
  selectedAnnee, setSelectedAnnee, anneesOptions,
  selectedGroup, setSelectedGroup, groupOptions,
}) => {
  return (
    <div className="flex justify-center mb-3 gap-2 flex-wrap">
      <select
        value={season}
        onChange={(e) => setSeason(e.target.value)}
        className="p-2 border rounded appearance-none bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-white"
      >
        {seasonOptions.map((s) => (
          <option key={s} value={s} className="bg-gray-200 dark:bg-gray-700 dark:text-white">
            {s}
          </option>
        ))}
      </select>

      <select
        value={selectedGenre}
        onChange={(e) => setSelectedGenre(e.target.value)}
        className="p-2 border rounded appearance-none bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-white"
      >
        <option value="Tous" className="bg-gray-200 dark:bg-gray-700 dark:text-white">Tous les genres</option>
        <option value="Masculin" className="bg-gray-200 dark:bg-gray-700 dark:text-white">Masculin</option>
        <option value="Féminin" className="bg-gray-200 dark:bg-gray-700 dark:text-white">Féminin</option>
      </select>

      <select
        value={selectedAnnee}
        onChange={(e) => setSelectedAnnee(e.target.value)}
        className="p-2 border rounded appearance-none bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-white"
      >
        <option value="Tous" className="bg-gray-200 dark:bg-gray-700 dark:text-white">Toutes les années</option>
        {anneesOptions.map((y) => (
          <option key={y} value={y} className="bg-gray-200 dark:bg-gray-700 dark:text-white">
            {y}
          </option>
        ))}
      </select>

      <select
        value={selectedGroup}
        onChange={(e) => setSelectedGroup(e.target.value)}
        className="p-2 border rounded appearance-none bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-white min-w-[12rem]"
        title="Filtrer par groupe d'entraînement"
      >
        <option value="" className="bg-gray-200 dark:bg-gray-700 dark:text-white">
          Tous les groupes
        </option>
        {groupOptions.map((g) => (
          <option key={g} value={g} className="bg-gray-200 dark:bg-gray-700 dark:text-white">
            {g}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FiltersBar;
